import { render, staticRenderFns } from "./FormDatepicker.vue?vue&type=template&id=53e996c6&"
import script from "./FormDatepicker.vue?vue&type=script&lang=js&"
export * from "./FormDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports